import { AppBar, Button, Chip, makeStyles, Toolbar, Typography } from '@material-ui/core';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setMessage } from '../../redux/message';
import { retractTimecard, submitTimecard } from '../../redux/timecard';
import { ENTRY_TYPE_DRAFT } from '../../config/staticValues';
import DayNavigator from './DayNavigator';
import TimecardSelector from './TimecardSelector';

const useStyles = makeStyles((theme) => ({
  appBar: {
    top: '80px',
    borderRadius: '10px',
  },
  selector: {
    flexGrow: 1,
  },
  subBar: {
    margin: '0px 20px',
  },
  navigator: {
    display: 'inline-block',
    maxWidth: '75%',
  },
  viewSelector: {
    float: 'right',
    marginBottom: '10px',
  },
}));
const TimecardNavigation = ({
  activeDay,
  setActiveDay,
  isTimelineView,
  toggleTimelineView,
  showPriorButton,
  timecardStatus,
}) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const timecard = useSelector((state) => state.timecard);
  const timecardId = timecard.timecardId;
  const handleSubmitClick = () => {
    const existsDrafts = !!timecard.entries.find(
      (entry) => entry.type === ENTRY_TYPE_DRAFT
    );
    if (existsDrafts)
      dispatch(
        setMessage("You can't submit your timecard if you still have drafts", 'error')
      );
    else dispatch(submitTimecard(timecardId));
  };
  const handleRetractClick = () => {
    dispatch(retractTimecard(timecardId));
  };
  const showSubmit = timecardStatus === 'DRAFT';
  const showRetract = timecardStatus === 'SUBMITTED';
  const showCompleted = !showSubmit && !showRetract;
  return (
    <AppBar position="sticky" className={classes.appBar} color="secondary">
      <Toolbar>
        <span className={classes.selector}>
          <TimecardSelector />
        </span>

        {showSubmit && (
          <Button variant="contained" color="primary" onClick={handleSubmitClick}>
            <Typography>Submit</Typography>
          </Button>
        )}
        {showRetract && (
          <Button variant="contained" color="primary" onClick={handleRetractClick}>
            <Typography>Retract</Typography>
          </Button>
        )}
        {showCompleted && <Chip label="Payroll processing" />}
      </Toolbar>
      <div className={classes.subBar}>
        {/* <div className={classes.navigator}>
          {isTimelineView && (
            <DayNavigator
              activeDay={activeDay}
              setActiveDay={setActiveDay}
              showPriorButton={showPriorButton}
            />
          )}
        </div> */}
        <div className={classes.viewSelector}>
          <Button variant="text" onClick={toggleTimelineView}>
            {isTimelineView ? 'View Timecard' : 'View Timeline'}
          </Button>
        </div>
      </div>
    </AppBar>
  );
};

export default TimecardNavigation;
